// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"975":"a3da76f4","986":"56c4fa20"}[chunkId] + ".chunk.js";
};